<template>
  <div class="bottom-menu" :class="{ isCatalogOpen: isMenuOpen }">
    <div class="list">
      <template v-for="(item, index) in bottomMenu">
        <nuxt-link
          v-if="item.url"
          :key="index"
          :to="item.url"
          :class="['item', item.img]"
          @click="closeCatalog"
        >
          <div
            :class="[
              'image-container',
              'click-ignore',
              `image-container--${item.img}`,
              {
                'image-container--favorite--active':
                  item.badge === 'favorites' && badges[item.badge] > 0,
              },
              {
                'image-container--comparison--active':
                  item.badge === 'compare' && badges[item.badge] > 0,
              },
            ]"
          >
            <UiIcon
              class="click-ignore image"
              :name="item.img"
              :response-size="[20, 20, 20, 20, 22, 22]"
              :fill="item.img === 'home' ? '' : '#ffffff'"
            />
            <span v-if="item.badge && badges[item.badge]" class="badge">{{
              badges[item.badge]
            }}</span>
          </div>
          <p class="title text-bottom-menu body-m-regular">
            {{ item.title }}
          </p>
        </nuxt-link>
        <div
          v-else
          :key="index + 'm'"
          :class="['item', item.img]"
          @click.prevent="togglecatalog"
        >
          <div :class="['image-container', `image-container--${item.img}`]">
            <UiIcon
              :name="item.img"
              size="20"
              :stroke="isMenuOpen ? '#363ef8' : ''"
            />
          </div>
          <p class="title text-bottom-menu">{{ item.title }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useGlobalStore } from '~/stores/global';
import { useFavoriteStore } from '~/stores/favorite';
import { useCompareStore } from '~/stores/compare';

const favoriteStore = useFavoriteStore();
const compareStore = useCompareStore();
const badges = computed(() => {
  return {
    favorites: favoriteStore.ids?.length,
    compare: compareStore.ids?.length,
  };
});
const emit = defineEmits(['toggleVisibleCatalog']);
const router = useRouter();

const globalStore = useGlobalStore();
const isMenuOpen = computed(() => globalStore.isMenuOpen);

const bottomMenu = [
  {
    title: 'Главная',
    img: 'home',
    url: '/',
  },
  {
    title: 'Каталог',
    img: 'catalog',
    url: null,
  },
  {
    title: 'Избранное',
    img: 'favorites',
    url: { path: '/favorite/' },
    badge: 'favorites',
  },
  {
    title: 'Сравнение',
    img: 'compare',
    url: { path: '/compare/' },
    badge: 'compare',
  },
];
const closeCatalog = (e: Event) => {
  const target = e.srcElement as HTMLElement;
  if (target?.className.includes('router-link-active')) {
    emit('toggleVisibleCatalog', false);
  }
};
router.afterEach(() => {
  setTimeout(() => {
    emit('toggleVisibleCatalog', false);
  }, 700);
});
const togglecatalog = () => {
  const html = document.querySelector('html') as HTMLElement | null;
  if (html) {
    html.classList.remove('has-modal');
  }
  emit('toggleVisibleCatalog', !isMenuOpen.value);
};
</script>

<style lang="scss" scoped>
.bottom-menu {
  width: 100%;
  background-color: $white;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 90;
  padding-bottom: env(safe-area-inset-bottom, 0);
  display: flex;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  box-shadow: 0px -2px 12px 0px rgba(85, 91, 143, 0.08);

  @include xl-block {
    display: none;
  }

  .list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      width: 25%;
      padding: 8px 0;

      .title {
        color: $achromatic-disabled;
        @include fz(9, 12, 500);
      }

      .image-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        margin-bottom: 2px;
        position: relative;
        gap: 2px;
        flex-direction: column;

        @include md-block {
          width: 36px;
        }

        .badge {
          position: absolute;
          top: -4px;
          left: 20px;
          background: $red1;
          border-radius: 20px;
          color: $white;
          text-align: center;
          font-style: normal;
          letter-spacing: 0.18px;
          padding: 2px;
          border: 1px solid $white;
          min-width: 16px;
          @include fz(9, 10, 600);
        }
      }
    }

    .nuxt-link-exact-active,
    .router-link-exact-active {
      .title {
        color: $main-cta;
      }
    }
  }
}

.isCatalogOpen {
  &.bottom-menu {
    .list .item .title {
      color: #86888f;
    }

    .list .item.catalog .title {
      color: $main-cta;
    }
  }
}

.click-ignore {
  pointer-events: none;
}

.image-container .image {
  margin-left: 1px;
  margin-top: 1px;
}

.favorite:hover .image-container--favorite .image,
.comparison:hover .image-container--comparison .image {
  :deep(svg) {
    stroke: $main-cta;
  }

  :deep(path) {
    stroke: $main-cta;
  }
}

.image-container--favorite--active .image,
.image-container--comparison--active .image {
  :deep(svg) {
    stroke: $main-cta;
  }

  :deep(path) {
    stroke: $main-cta;
  }
}
</style>
